import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/settings/capacity/')({
  loader: ({ params }) => {
    throw redirect({
      to: '/org/$org/settings/capacity/workload-scheme',
      params: { org: params.org },
    });
  },
});
